<template>
  <el-card class="indigo-widget">
    <div v-if="$slots.header" slot="header">
        <slot name="header"></slot>
    </div>
    <div class="row">
      <div class="col-4">
        <div style="width: 200px; height: 200px; float: left; position: relative;">
          <div class="doughnut-centre-label-container" style="width: 100%; height: 40px; position: absolute; top: 50%; left: 0; margin-top: -30px; line-height:14px; text-align: center; z-index: 999999999999999">
              <span>{{percentage1}}</span><br/>
              <span>Leads</span>
          </div>
          <div style="width: 200px; height: 200px;">
              <doughnut-chart v-if="loaded" :data="datasets1" :options="options" class="col-12 w-100"></doughnut-chart>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div style="width: 200px; height: 200px; float: left; position: relative;">
          <div class="doughnut-centre-label-container" style="width: 100%; height: 40px; position: absolute; top: 50%; left: 0; margin-top: -30px; line-height:14px; text-align: center; z-index: 999999999999999">
              <span>{{percentage2*100}}%</span><br/>
              <span>Apps Taken</span>
          </div>
          <div style="width: 200px; height: 200px;">
              <doughnut-chart v-if="loaded" :data="datasets2" :options="options" class="col-12 w-100"></doughnut-chart>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div style="width: 200px; height: 200px; float: left; position: relative;">
          <div class="doughnut-centre-label-container" style="width: 100%; height: 40px; position: absolute; top: 50%; left: 0; margin-top: -30px; line-height:14px; text-align: center; z-index: 999999999999999">
              <span>{{percentage3*100}}%</span><br/>
              <span>No Contact<br/>/Closed</span>
          </div>
          <div style="width: 200px; height: 200px;">
              <doughnut-chart v-if="loaded" :data="datasets3" :options="options" class="col-12 w-100"></doughnut-chart>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>


<script>
import DoughnutChart from "./charts/DoughnutChart";
export default {
  components: {
    DoughnutChart
  },
  props: {
    token: {
      type: String,
      required: true
    },
    dateScope: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      monthlyLeads: [],
      percentage1: 0,
      percentage2: 0,
      percentage3: 0,
      datasets1: [],
      datasets2: [],
      datasets3: [],
      loaded: false,
      options: {
        responsive: true,
        cutoutPercentage: 75,
        legend: {
          display: false
        },
        tooltips: {
            enabled: false
        },
        maintainAspectRatio: true
      }
    };
  },
  mounted() {
    this.$bus.$on("refreshed-data", value => {
      this.refreshData();
    });
  },
  watch: {
    dateScope: {
      handler(newVal, oldVal) {
        this.refreshData();
      },
      deep: true
    }
  },
  methods: {
    refreshData() {
      this.getMonthlyLeads();
    },
    async getMonthlyLeads() {
      try {
        // this.loaded = false;
        let res = await axios.get(`/api/v2/monthly-leads`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            period: this.dateScope.format("YYYY-MM-DD")
          }
        });
        this.monthlyLeads = res.data;

        this.percentage1 = this.monthlyLeads[0].leads;
        this.percentage2 = Number(this.monthlyLeads[0].app_taken_percent).toFixed(2);
        this.percentage3 = Number(this.monthlyLeads[0].remainder_percent).toFixed(2);

        let datasets1 = [[100]];
        let datasets2 = [
          [this.monthlyLeads[0].app_taken_percent],
          [this.monthlyLeads[0].remainder_percent]
        ];
        let datasets3 = [
          [this.monthlyLeads[0].remainder_percent],
          [this.monthlyLeads[0].app_taken_percent]
        ];

        this.datasets1 = {
          datasets: [
            {
              data: datasets1,
              backgroundColor: [
                "#3F51B5"
              ],
              borderColor: "#000000",
              borderWidth: 1
            }
          ],
          labels: []
        };
        this.datasets2 = {
          datasets: [
            {
              data: datasets2,
              backgroundColor: [
                "#009688",
                "#FFFFFF"
              ],
              borderColor: "#000000",
              borderWidth: 1
            }
          ],
          labels: []
        };
        this.datasets3 = {
          datasets: [
            {
              data: datasets3,
              backgroundColor: [
                "#E91E63",
                "#FFFFFF"
                // "#3F51B5",
                // "#009688",
                // "#2196F3",
                // "#673AB7",
                // "#FFC107",
                // "#4CAF50",
                // "#9E9E9E",
                // "#795548",
                // "#607D8B",
                // "#00BCD4",
                // "#E91E63"
              ],
              borderColor: "#000000",
              borderWidth: 1
            }
          ],
          labels: []
        };
        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style>
    .doughnut-centre-label-container {
        font-family: "Poppins";
        font-size: 14px;
    }
    .doughnut-centre-label-container span {
        font-size: 12px;
        font-weight: 500;
    }
</style>
